import script from "./ProjectByIdView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectByIdView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectByIdView.vue?vue&type=style&index=0&id=2e6ac452&lang=scss&scoped=true"
import "./ProjectByIdView.vue?vue&type=style&index=1&id=2e6ac452&lang=css"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e6ac452"]])

export default __exports__